import { useNavigate, useParams } from "react-router-dom";
import ReusableTable from "../../ReusableTable/ReusableTable";
import { env } from "../../../constants/env";
import { useEffect, useState } from "react";
import axios from "axios";
import { useAuth } from "../../../context/AuthContext";
import { toast } from "react-toastify";

const OrganizationLeadership = () => {
  const navigate = useNavigate();
  const [tableData, setTableData] = useState([]);
  const { user } = useAuth();
  const userRole = user?.role;

  const { labId } = useParams(); // Replace with actual lab ID (from context, props, or auth)
  const name = "SLIPTA";
  const section = "Organization & Leadership";

  useEffect(() => {
    const fetchSummary = async () => {
      try {
        const response = await axios.get(
          `${env.kataApiUrl}/api/certification/summary`,
          {
            params: { labId, name, section },
          }
        );

        // response.data is an array of objects
        const formattedData = response.data.map((item) => ({
          title: `SLIPTA - ${section}`, // or item.title if API provides it
          totalScore: item.totalScore,
          created: new Date(item.createdAt).toLocaleDateString(),
          updated: new Date(item.updatedAt).toLocaleDateString(),
          status: item.status,
          id: item._id,
        }));

        setTableData(formattedData);
      } catch (error) {
        console.error("Error fetching certification summary:", error);
      }
    };

    fetchSummary();
  }, [labId, name, section]);

  const sectionColumns = [
    { label: "Title", field: "title" },
    { label: "Total Score", field: "totalScore" },
    { label: "Created", field: "created" },
    { label: "Updated", field: "updated" },
    { label: "Status", field: "status" },
  ];
  return (
    <div>
      <ReusableTable
        title="Organization & leadership"
        showTopAdd={userRole === "ASSESSOR" ? tableData.length > 0 : false}
        columns={sectionColumns}
        data={tableData}
        onAdd={
          userRole === "ASSESSOR"
            ? () => navigate("add-organization-leadership")
            : false
        }
        showDetails={false}
        onEdit={
          (row) => {
            if (row.status === "Attached") {
              toast.error("Can not edit as document is already attached");
            } else {
              navigate(`add-organization-leadership/${row.id}`);
            }
          } // edit mode
        }
      />
    </div>
  );
};

export default OrganizationLeadership;
